
import React, { useState, useEffect } from 'react';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, isResultOk } from './../../components/special/apiCall';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextRegno from './../../components/text/TextRegno';
import TextPhonenumber from './../../components/text/TextPhonenumber';
import ReactTooltip  from 'react-tooltip';
import TextDate from 'components/text/TextDate';
import TextNumber from 'components/text/TextNumber';
import TextAmount from 'components/text/TextAmount';
import TextDateTime from './../../components/text/TextDateTime';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const CommandList = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/management/job/command/summary');
    if (isResultOk(data, setListError, true)){        
      console.log("Data",data);
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  return (    
    <div>      
      <ListHeader title={t("Aðgerðir")}/>
      <ReactTooltip/>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['180px', '8%', '14%', '8%', '50%']}
          headers = {[
            t("Aðgerðarkóði"),            
            t("Staða"),
            t("Síðast keyrt"),
            t("Tími"),
            t("Síðastu sk.b."),
          ]}
          columns = {[
            (item) => (<><a href={"/admin/jobs/runs?commandid=" + item.commandID}>{item.command}</a></>),            
            (item) => (<>{ item.statusName }</>),
            (item) => (<TextDateTime value={item.lastRun}/>),
            (item) => (<><TextAmount value={item.lastRunTime}/> {item.lastRunTime && <span>sek</span>}</>),
            (item) => (<>{ item.lastMessage }</>),
          ]}

      />
  </div>
  );
};




